import PopularAddonsContent from "./popular-addons-content.jsx";
import { h, render } from "preact";
import storefront from "../../helpers/storefront/index.js";
import * as queries from "../../helpers/storefront/queries.js";

class PopularAddons extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.container = this.querySelector("[data-popular-addons-container]");

    this.init();
  }

  init = async () => {
    if (this.data.productsConfiguration?.length <= 0) return;

    const configOptions = await storefront.request({
      query: queries.products,
      variables: {
        ids: this.data.productsConfiguration.map((id) =>
          encodeId(id, "Product"),
        ),
      },
    });

    const products = configOptions.data.nodes;
    const groupSets = {};

    await Promise.all(
      products.map(async (product) => {
        const groupTag = product?.tags?.find((t) => t.includes("group:"));
        if (!groupTag) return;
        const response = await storefront.request({
          query: queries.productsByTag(groupTag),
        });
        if (response?.data?.products) {
          const groupProducts = response.data.products.edges.filter((p) => p);
          const productsClean = groupProducts.map(
            (p) => p.node?.variants?.edges[0],
          );
          const productOptions = productsClean.map(
            (p) => p.node?.selectedOptions[0],
          );
          groupSets[product.id] = {
            products: groupProducts,
            options: productOptions,
          };
        }
      }),
    );

    const PopularAddonsComponent = () => {
      return (
        <PopularAddonsContent
          data={this.data}
          form={this.closest("product-form")}
          groupSets={groupSets}
          bundle={products}
        />
      );
    };

    this.container && render(<PopularAddonsComponent />, this.container);
  };
}

if (!customElements.get("popular-addons")) {
  customElements.define("popular-addons", PopularAddons);
}
